'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitSaveSearch = exports.getSaveSearchParams = exports.getSaveSearchState = exports.DELETE_SAVED_SEARCH_SUCCESS = exports.DELETE_SAVED_SEARCH_REQUEST = exports.DELETE_SAVED_SEARCH_FAIL = exports.SAVE_SEARCH_SUCCESS = exports.SAVE_SEARCH_REQUEST = exports.SAVE_SEARCH_FAIL = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.deleteSavedSearch = deleteSavedSearch;

var _searchParams = require('../../utils/searchParams');

var _user = require('./user');

var _analytics = require('./analytics');

var _saveSearchCheck = require('./saveSearchCheck');

var _api = require('../api');

var _savedSearch = require('./savedSearch');

var _config = require('./config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SAVE_SEARCH_FAIL = exports.SAVE_SEARCH_FAIL = 'la/ui/saveSearch/FAIL';
var SAVE_SEARCH_REQUEST = exports.SAVE_SEARCH_REQUEST = 'la/ui/saveSearch/REQUEST';
var SAVE_SEARCH_SUCCESS = exports.SAVE_SEARCH_SUCCESS = 'la/ui/saveSearch/SUCCESS';

var DELETE_SAVED_SEARCH_FAIL = exports.DELETE_SAVED_SEARCH_FAIL = 'la/ui/deleteSavedSearch/FAIL';
var DELETE_SAVED_SEARCH_REQUEST = exports.DELETE_SAVED_SEARCH_REQUEST = 'la/ui/deleteSavedSearch/REQUEST';
var DELETE_SAVED_SEARCH_SUCCESS = exports.DELETE_SAVED_SEARCH_SUCCESS = 'la/ui/deleteSavedSearch/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SAVE_SEARCH_REQUEST:
        case DELETE_SAVED_SEARCH_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case SAVE_SEARCH_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case _user.LOG_OUT_BIDDER:
        case DELETE_SAVED_SEARCH_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case SAVE_SEARCH_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var getSaveSearchState = exports.getSaveSearchState = function getSaveSearchState(state) {
    return state.ui.saveSearch;
};

var getSaveSearchParams = exports.getSaveSearchParams = function getSaveSearchParams(location) {
    var searchParams = (0, _searchParams.getSearchParams)(location);

    if (searchParams.status === _searchParams.DEFAULT_STATUS_FOR_ARCHIVED_SEARCH) {
        searchParams.status = _searchParams.DEFAULT_STATUS_FOR_ONLINE_SEARCH;
    }

    delete searchParams.pageSize;
    delete searchParams.pagesize;
    delete searchParams.page;
    delete searchParams.sort;

    searchParams.keyword = searchParams.keyword ? searchParams.keyword : '';

    return searchParams;
};

/* ACTION CREATORS */
var submitSaveSearch = exports.submitSaveSearch = function submitSaveSearch(searchParams, sendAlert) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        var analytics = (0, _analytics.getFollowSearchAnalytics)();
        dispatch({
            type: SAVE_SEARCH_REQUEST
        });
        return _api.SaveSearch.postSaveSearch({ authToken: authToken, deployment: deployment, searchParams: searchParams, sendAlert: sendAlert }).then(function (response) {
            dispatch({
                meta: analytics,
                payload: response,
                type: SAVE_SEARCH_SUCCESS
            });
            dispatch((0, _savedSearch.fetchSavedSearchesIfNeeded)(true));
            dispatch((0, _saveSearchCheck.submitIsSavedSearchCheck)(searchParams));
        }).catch(function (error) {
            dispatch({
                error: true,
                payload: error,
                type: SAVE_SEARCH_FAIL
            });
            dispatch((0, _savedSearch.fetchSavedSearchesIfNeeded)(true));
            dispatch((0, _saveSearchCheck.submitIsSavedSearchCheck)(searchParams));
        });
    };
};

function deleteSavedSearch(searchParams) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        var savedSearchId = (0, _saveSearchCheck.getSavedSearchId)(state);
        var analytics = (0, _analytics.getUnfollowSearchAnalytics)();
        dispatch({
            type: DELETE_SAVED_SEARCH_REQUEST
        });
        return _api.SaveSearch.postDeleteSavedSearch({ authToken: authToken, deployment: deployment, savedSearchId: savedSearchId }).then(function (response) {
            dispatch({ meta: analytics, payload: response.payload, type: DELETE_SAVED_SEARCH_SUCCESS });
            dispatch((0, _savedSearch.fetchSavedSearchesIfNeeded)(true));
            dispatch((0, _saveSearchCheck.submitIsSavedSearchCheck)(searchParams));
        }).catch(function (error) {
            dispatch({
                error: true,
                payload: error,
                type: DELETE_SAVED_SEARCH_FAIL
            });
            dispatch((0, _savedSearch.fetchSavedSearchesIfNeeded)(true));
            dispatch((0, _saveSearchCheck.submitIsSavedSearchCheck)(searchParams));
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/saveSearch.js
// module id = AwUZ
// module chunks = 60